import { render, staticRenderFns } from "./bannerIndex.vue?vue&type=template&id=0201eb3c&"
import script from "./bannerIndex.vue?vue&type=script&lang=js&"
export * from "./bannerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bannerIndex.vue"
export default component.exports